import React, { useEffect, useState, useRef } from "react";
import "./DistrictCourtCaseForm.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useLoading } from "../../context/LoadingContext";
import { saveDistrictCourtCaseForm } from "../../services/api/DistrictCourtApi";
import {
  getBothCourtCasesDetailsByCourtRef,
  getdcdatabycourtRef,
  UpdateDistrictManualCase,
} from "../../services/api/CasesApi";
import { useToast } from "../../context/ToastContext";
import { useAuth } from "../../context/AuthContext";
import { uploadFileWithProgress } from "../../utils/ftpUploadUtils";
import { FetchingOverlay } from "../../components/FetchingOverlay/FetchingOverlay";

export const DistrictCourtCaseForm = ({ isEdit = false }) => {
  const navigate = useNavigate();
  const formRef = useRef(null); // Reference to the form element
  const submitSectionRef = useRef(null);
  const partyDetailsRefs = useRef([]);
  const respondentDetailsRefs = useRef([]);
  const actsAndSectionsRefs = useRef([]);
  const historyDataRefs = useRef([]);
  const ordersRefs = useRef([]);
  const transferDetailsRefs = useRef([]);
  const { isLoading, showLoading, hideLoading } = useLoading();
  const [fetchCourtRef, setFetchCourtRef] = useState("");
  const fetchInputRef = useRef(null);


  const { company } = useAuth();
  const [uploadingOrders, setUploadingOrders] = useState({});
  const [uploadProgressOrders, setUploadProgressOrders] = useState({});
  const [activePartyIndex, setActivePartyIndex] = useState(0);
  const [activeRespondentIndex, setActiveRespondentIndex] = useState(0);
  const [activeActSectionIndex, setActiveActSectionIndex] = useState(0);
  const [activeTransferIndex, setActiveTransferIndex] = useState(0);
  const [activeHistoryIndex, setActiveHistoryIndex] = useState(0);
  const [activeOrderIndex, setActiveOrderIndex] = useState(0);


  const [formData, setFormData] = useState({
    courtName: "",
    court: "",
    serialNumber: "",
    caseTypeAndNumber: "",
    parties: "",
    advocates: "",
    viewDetails: {
      caseId: "",
      courtRef: "",
      index: "",
      hideparty: "",
      caseStatusSearchType: "",
      // state_code: '',
      // dist_code: '',
      // complex_code: '',
      type: "",
    },
    caseStatus: {
      "First Hearing Date": "",
      "Next Hearing Date": "",
      "Decision Date": "",
      "Case Status": "",
      "Nature of Disposal": "",
      "Court Number and Judge": "",

    },
    caseDetails: {
      "Case Type": "",
      "Filing Number": "",
      "Filing Date": "",
      "Registration Number": "",
      "Registration Date:": "",
      "CNR Number": "",
    },
    partyDetails: [""],
    respondentDetails: [{ party: "", advocate: "" }],
    actsAndSections: [{ act: "", section: "" }],
    transferDetails: [
      {
        "Registeration Number": "",
        "Transfer Date": "",
        "From Court Number and Judge": "",
        "To Court Number and Judge": "",
      },
    ],
    historyData: [
      { judge: "", businessOnDate: "", hearingDate: "", purposeOfHearing: "" },
    ],
    orders: [
      {
        orderNumber: "",
        orderDate: "",
        orderTitle: "",
        // documentLink: "",
        orderPdfLink: "",
      },
    ],
  });
  const { courtRef } = useParams();
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  useEffect(() => {
    // Auto-focus the fetch input when creating a new case (not editing)
    if (fetchInputRef && fetchInputRef.current) {
      // timeout ensures the element is mounted
      setTimeout(() => {
        try {
          fetchInputRef.current.focus();
          const val = fetchInputRef.current.value || '';
          fetchInputRef.current.setSelectionRange(val.length, val.length);
        } catch (e) {
          // ignore
        }
      }, 0);
    }
  }, [isEdit, courtRef]);
  const { showToast } = useToast();

  const handleOrderFileUpload = async (selectedFile, index) => {
    if (!selectedFile) return;

    const orderKey = `order_${index}`;
    setUploadingOrders(prev => ({ ...prev, [orderKey]: true }));
    setUploadProgressOrders(prev => ({ ...prev, [orderKey]: 0 }));

    try {
      const filePath = company?._id ? `/${company._id}/dc/added/${formData.viewDetails.courtRef}/orders` : '/unknown/orders';

      await uploadFileWithProgress(
        selectedFile,
        filePath,
        // Progress callback
        (progress) => {
          setUploadProgressOrders(prev => ({ ...prev, [orderKey]: progress }));
        },
        // Success callback
        (result) => {
          const updatedOrders = [...formData.orders];
          updatedOrders[index].orderPdfLink = result.imageUrl;
          setFormData(prev => ({ ...prev, orders: updatedOrders }));
          setUploadingOrders(prev => ({ ...prev, [orderKey]: false }));
          showToast('Order file uploaded successfully!', 'success');
        },
        // Error callback
        (error) => {
          console.error("Order file upload failed:", error);
          setUploadingOrders(prev => ({ ...prev, [orderKey]: false }));
          setUploadProgressOrders(prev => ({ ...prev, [orderKey]: 0 }));
          showToast(error.message || 'Order file upload failed', 'error');
        }
      );
    } catch (error) {
      console.error("Order file upload failed:", error);
      setUploadingOrders(prev => ({ ...prev, [orderKey]: false }));
      setUploadProgressOrders(prev => ({ ...prev, [orderKey]: 0 }));
      showToast(error.message || 'Order file upload failed', 'error');
    }
  };

  const handleOrderFileChange = (e, index) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      handleOrderFileUpload(selectedFile, index);
    }
  };

  const handleRemoveOrderFile = (index) => {
    const updatedOrders = [...formData.orders];
    updatedOrders[index].orderPdfLink = "";
    setFormData(prev => ({ ...prev, orders: updatedOrders }));

    // Clear upload states
    const orderKey = `order_${index}`;
    setUploadingOrders(prev => ({ ...prev, [orderKey]: false }));
    setUploadProgressOrders(prev => ({ ...prev, [orderKey]: 0 }));
  };
  const stateOptions = [
    { code: "01", name: "Jammu & Kashmir" },
    { code: "02", name: "Himachal Pradesh" },
    { code: "03", name: "Punjab" },
    { code: "04", name: "Chandigarh" },
    { code: "05", name: "Uttarakhand" },
    { code: "06", name: "Haryana" },
    { code: "07", name: "Delhi" },
    { code: "08", name: "Rajasthan" },
    { code: "09", name: "Uttar Pradesh" },
    { code: "10", name: "Bihar" },
  ];

  const districtOptionsMap = {
    "01": [
      { code: "001", name: "Srinagar" },
      { code: "002", name: "Jammu" },
      { code: "003", name: "Baramulla" },
    ],
    "02": [
      { code: "004", name: "Shimla" },
      { code: "005", name: "Kangra" },
      { code: "006", name: "Mandi" },
    ],
    "03": [
      { code: "007", name: "Amritsar" },
      { code: "008", name: "Ludhiana" },
    ],
    "04": [{ code: "009", name: "Chandigarh District" }],
    "05": [
      { code: "010", name: "Dehradun" },
      { code: "011", name: "Nainital" },
    ],
    "06": [
      { code: "012", name: "Gurgaon" },
      { code: "013", name: "Faridabad" },
    ],
    "07": [
      { code: "014", name: "New Delhi" },
      { code: "015", name: "South Delhi" },
    ],
    "08": [
      { code: "016", name: "Jaipur" },
      { code: "017", name: "Jodhpur" },
    ],
    "09": [
      { code: "061", name: "Lucknow" },
      { code: "062", name: "Kanpur Nagar" },
      { code: "063", name: "Varanasi" },
    ],
    10: [
      { code: "018", name: "Patna" },
      { code: "019", name: "Gaya" },
    ],
  };
  const complexOptionsMap = {
    "001": [
      { code: "0011", name: "Srinagar Main Complex" },
      { code: "0012", name: "Srinagar Family Court" },
    ],
    "002": [
      { code: "0021", name: "Jammu District Court" },
      { code: "0022", name: "Jammu Consumer Forum" },
    ],
    "004": [
      { code: "0041", name: "Shimla High Court Complex" },
      { code: "0042", name: "Shimla District Court" },
    ],
    "061": [
      { code: "0611", name: "Lucknow Civil Court" },
      { code: "0612", name: "Lucknow Criminal Court" },
    ],
    "062": [
      { code: "0621", name: "Kanpur Nagar Civil" },
      { code: "0622", name: "Kanpur Nagar Family Court" },
    ],
    "063": [
      { code: "0631", name: "Varanasi District Complex" },
      { code: "0632", name: "Varanasi Sessions Court" },
    ],
    "016": [
      { code: "0161", name: "Jaipur District Court" },
      { code: "0162", name: "Jaipur Civil Court" },
    ],
    "014": [
      { code: "0141", name: "Tis Hazari" },
      { code: "0142", name: "Karkardooma" },
    ],
    "018": [
      { code: "0181", name: "Patna High Court" },
      { code: "0182", name: "Patna Civil Court" },
    ],
  };

  useEffect(() => {
    const submitSection = submitSectionRef.current;
    const submitSectionTop = document.querySelector(".dc-submit-section");

    if (!submitSection || !submitSectionTop) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          submitSectionTop.classList.add("hidden");
        } else {
          submitSectionTop.classList.remove("hidden");
        }
      },
      {
        root: null, // Use viewport as root
        threshold: 0.1, // Trigger when 10% of .hc-submit-section is visible
      }
    );

    observer.observe(submitSection);

    return () => {
      observer.unobserve(submitSection);
    };
  }, []);

  const handleTopSubmit = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true })
      );
    }
  };

  // Helper function to convert date from DD-MM-YYYY to YYYY-MM-DD
  // const convertDateToInputFormat = (dateStr) => {
  //   if (!dateStr || dateStr === "") return "";

  //   // Handle different date formats
  //   let parts;
  //   if (dateStr.includes("-")) {
  //     parts = dateStr.split("-");
  //   } else if (dateStr.includes("/")) {
  //     parts = dateStr.split("/");
  //   } else {
  //     return dateStr; // Return as is if format is unknown
  //   }

  //   if (parts.length === 3) {
  //     // Assuming DD-MM-YYYY or DD/MM/YYYY format
  //     const [day, month, year] = parts;
  //     return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  //   }

  //   return dateStr;
  // };

  // Helper function to convert date from various formats to YYYY-MM-DD
  const convertDateToInputFormat = (dateStr) => {
    if (!dateStr || dateStr === "") return "";

    // Handle formats like "23rd March 2023" or "08th April 2023"
    const textDateMatch = dateStr.match(/(\d{1,2})(st|nd|rd|th)?\s+(\w+)\s+(\d{4})/i);
    if (textDateMatch) {
      const day = textDateMatch[1].padStart(2, '0');
      const monthName = textDateMatch[3];
      const year = textDateMatch[4];

      // Month name to number mapping
      const months = {
        january: '01', february: '02', march: '03', april: '04',
        may: '05', june: '06', july: '07', august: '08',
        september: '09', october: '10', november: '11', december: '12'
      };

      const month = months[monthName.toLowerCase()];
      if (month) {
        return `${year}-${month}-${day}`;
      }
    }

    // Handle different date formats (DD-MM-YYYY or DD/MM/YYYY)
    let parts;
    if (dateStr.includes("-")) {
      parts = dateStr.split("-");
    } else if (dateStr.includes("/")) {
      parts = dateStr.split("/");
    } else {
      return dateStr; // Return as is if format is unknown
    }

    if (parts.length === 3) {
      // Check if it's already in YYYY-MM-DD format
      if (parts[0].length === 4) {
        return dateStr; // Already in correct format
      }

      // Assuming DD-MM-YYYY or DD/MM/YYYY format
      const [day, month, year] = parts;
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }

    return dateStr;
  };
  // Helper 1: Convert YYYY-MM-DD to "14th August 2014" (For caseStatus)
  const formatToReadableDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return "";
    const parts = dateStr.split('-');
    if (parts.length !== 3) return dateStr;

    const [year, month, day] = parts;
    const dayNum = parseInt(day, 10);
    const monthIndex = parseInt(month, 10) - 1;

    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return n + 'th';
      switch (n % 10) {
        case 1: return n + "st";
        case 2: return n + "nd";
        case 3: return n + "rd";
        default: return n + "th";
      }
    };

    return `${getOrdinal(dayNum)} ${monthNames[monthIndex]} ${year}`;
  };

  // Helper 2: Convert YYYY-MM-DD to "DD-MM-YYYY" (For caseDetails)
  const formatToDDMMYYYY = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return "";
    const parts = dateStr.split('-'); // Expecting YYYY-MM-DD
    if (parts.length !== 3) return dateStr;
    const [year, month, day] = parts;
    return `${day}-${month}-${year}`;
  };

  // Function to populate form with fetched data
  const populateFormWithFetchedData = (apiData) => {
    // const data = apiData.data;
    const data = apiData.data.data;

    setFormData((prevData) => ({
      ...prevData,
      // Populate case status

      courtName: data.courtName || "",

      // Parties (first petitioner vs first respondent)
      parties: `${(data.partyDetails?.[0] || "")
        .replace(/^\d+\)\s*/, "") // remove leading "1) "
        .replace(/\n.*$/, "") // remove advocate info after newline
        .trim()} vs ${(data.respondentDetails?.[0]?.party || "")
          .replace(/^\d+\)\s*/, "") // remove leading "1) "
          .trim()}`,

      viewDetails: {
        ...prevData.viewDetails, // Keep existing viewDetails
        // Don't override courtRef since user already entered it
      },

      caseStatus: {
        "First Hearing Date": convertDateToInputFormat(
          data.caseStatus?.["First Hearing Date"] || ""
        ),
        "Next Hearing Date": convertDateToInputFormat(
          data.caseStatus?.["Next Hearing Date"] || ""
        ),
        "Decision Date": convertDateToInputFormat(
          data.caseStatus?.["Decision Date"] || ""
        ),
        "Case Status":
          data.caseStatus?.["Case Status"] === "Case disposed"
            ? "Disposed"
            : "Pending",
        "Nature of Disposal": data.caseStatus?.["Nature of Disposal"] || "",
        "Court Number and Judge":
          data.caseStatus?.["Court Number and Judge"] || "",
      },

      // Populate case details
      caseDetails: {
        "Case Type": data.caseDetails?.["Case Type"] || "",
        "Filing Number": data.caseDetails?.["Filing Number"] || "",
        "Filing Date": convertDateToInputFormat(
          data.caseDetails?.["Filing Date"] || ""
        ),
        "Registration Number": data.caseDetails?.["Registration Number"] || "",
        "Registration Date:": convertDateToInputFormat(
          data.caseDetails?.["Registration Date:"] || ""
        ),
        "CNR Number": data.caseDetails?.["CNR Number"] || "",
      },

      // Populate party details
      partyDetails:
        data.partyDetails && data.partyDetails.length > 0
          ? data.partyDetails
          : [""],

      // Populate respondent details
      respondentDetails:
        data.respondentDetails && data.respondentDetails.length > 0
          ? data.respondentDetails
          : [{ party: "", advocate: "" }],

      // Populate acts and sections
      actsAndSections:
        data.actsAndSections && data.actsAndSections.length > 0
          ? data.actsAndSections
          : [{ act: "", section: "" }],

      // Populate transfer details
      transferDetails:
        data.transferDetails && data.transferDetails.length > 0
          ? data.transferDetails.map((transfer) => ({
            "Registeration Number": transfer["Registeration Number"] || "",
            "Transfer Date": convertDateToInputFormat(
              transfer["Transfer Date"] || ""
            ),
            "From Court Number and Judge":
              transfer["From Court Number and Judge"] || "",
            "To Court Number and Judge":
              transfer["To Court Number and Judge"] || "",
          }))
          : [
            {
              "Registeration Number": "",
              "Transfer Date": "",
              "From Court Number and Judge": "",
              "To Court Number and Judge": "",
            },
          ],

      // Populate history data
      historyData:
        data.historyData && data.historyData.length > 0
          ? data.historyData.map((history) => ({
            judge: history.judge || "",
            businessOnDate: convertDateToInputFormat(
              history.businessOnDate || ""
            ),
            hearingDate: convertDateToInputFormat(history.hearingDate || ""),
            purposeOfHearing: history.purposeOfHearing || "",
          }))
          : [
            {
              judge: "",
              businessOnDate: "",
              hearingDate: "",
              purposeOfHearing: "",
            },
          ],

      // Populate orders
      orders:
        data.orders && data.orders.length > 0
          ? data.orders.map((order) => ({
            orderNumber: order.orderNumber || "",
            orderDate: convertDateToInputFormat(order.orderDate || ""),
            orderTitle: order.orderTitle || "",
            // documentLink: order.documentLink || "",
            orderPdfLink: order.orderPdfLink || "",
          }))
          : [
            {
              orderNumber: "",
              orderDate: "",
              orderTitle: "",
              // documentLink: "",
              orderPdfLink: "",
            },
          ],
    }));
  };

  const handleFetchDetails = async () => {
    if (!formData.viewDetails.courtRef.trim()) {
      showToast("Please enter a Court Reference number first", "error");
      return;
    }

    setIsFetchingDetails(true);
    try {
      const response = await getdcdatabycourtRef(formData.viewDetails.courtRef);

      if (response.data && response.data.success && response.data.data) {
        // FIX: Pass the entire response object
        populateFormWithFetchedData(response);
        showToast(
          "Case details fetched and populated successfully!",
          "success"
        );
      } else {
        showToast(
          "No case data found for the provided Court Reference",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching case details:", error);
      showToast(
        "Failed to fetch case details. Please check the Court Reference and try again.",
        "error"
      );
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleHistoryChange = (e, index) => {
    const { name, value } = e.target;
    const updated = [...formData.historyData];
    updated[index][name] = value;
    setFormData({ ...formData, historyData: updated });
  };

  const addHistoryRow = () => {
    setFormData((prev) => {
      const newHistoryData = [
        ...prev.historyData,
        {
          judge: "",
          businessOnDate: "",
          hearingDate: "",
          purposeOfHearing: "",
        },
      ];
      setActiveHistoryIndex(newHistoryData.length - 1);

      setTimeout(() => {
        if (historyDataRefs.current[newHistoryData.length - 1]) {
          historyDataRefs.current[newHistoryData.length - 1].focus();
        }
      }, 0);
      return {
        ...prev,
        historyData: newHistoryData,
      };
    });
  };
  const handleOrderChange = (e, index) => {
    const { name, value } = e.target;
    const updatedOrders = [...formData.orders];
    updatedOrders[index][name] = value;
    setFormData({ ...formData, orders: updatedOrders });
  };

  const addOrder = () => {
    const newOrder = {
      orderNumber: "",
      orderDate: "",
      orderTitle: "",
      // documentLink: "",
      orderPdfLink: "",
    };
    setFormData((prev) => {
      const newOrders = [...prev.orders, newOrder];
      setActiveOrderIndex(newOrders.length - 1);

      setTimeout(() => {
        if (ordersRefs.current[newOrders.length - 1]) {
          ordersRefs.current[newOrders.length - 1].focus();
        }
      }, 0);
      return {
        ...prev,
        orders: newOrders,
      };
    });
  };

  const removeOrder = (index) => {
    const updatedOrders = [...formData.orders];
    updatedOrders.splice(index, 1);
    if (index === activeOrderIndex) {
      setActiveOrderIndex(updatedOrders.length > 0 ? updatedOrders.length - 1 : 0);
    } else if (index < activeOrderIndex) {
      setActiveOrderIndex(prev => prev - 1);
    }
    setFormData((prev) => ({ ...prev, orders: updatedOrders }));
  };

  const removeHistoryRow = (index) => {
    const updated = [...formData.historyData];
    updated.splice(index, 1);
    if (index === activeHistoryIndex) {
      setActiveHistoryIndex(updated.length > 0 ? updated.length - 1 : 0);
    } else if (index < activeHistoryIndex) {
      setActiveHistoryIndex(prev => prev - 1);
    }
    setFormData({ ...formData, historyData: updated });
  };

  const handleTransferChange = (e, index, key) => {
    const updated = [...formData.transferDetails];
    updated[index][key] = e.target.value;
    setFormData({ ...formData, transferDetails: updated });
  };

  const addTransfer = () => {
    setFormData((prev) => {
      const newTransferDetails = [
        ...prev.transferDetails,
        {
          "Registeration Number": "",
          "Transfer Date": "",
          "From Court Number and Judge": "",
          "To Court Number and Judge": "",
        },
      ];
      setActiveTransferIndex(newTransferDetails.length - 1);

      setTimeout(() => {
        if (transferDetailsRefs.current[newTransferDetails.length - 1]) {
          transferDetailsRefs.current[newTransferDetails.length - 1].focus();
        }
      }, 0);
      return {
        ...prev,
        transferDetails: newTransferDetails,
      };
    });
  };

  const removeTransfer = (index) => {
    const updated = [...formData.transferDetails];
    updated.splice(index, 1);
    if (index === activeTransferIndex) {
      setActiveTransferIndex(updated.length > 0 ? updated.length - 1 : 0);
    } else if (index < activeTransferIndex) {
      setActiveTransferIndex(prev => prev - 1);
    }
    setFormData({ ...formData, transferDetails: updated });
  };
  const addPartyDetail = () => {
    setFormData((prev) => {
      const newPartyDetails = [...prev.partyDetails, ""];
      setActivePartyIndex(newPartyDetails.length - 1);
      setTimeout(() => {
        if (partyDetailsRefs.current[newPartyDetails.length - 1]) {
          partyDetailsRefs.current[newPartyDetails.length - 1].focus();
        }
      }, 0);
      return {
        ...prev,
        partyDetails: newPartyDetails,
      };
    });
  };

  const removePartyDetail = (index) => {
    const updated = [...formData.partyDetails];
    updated.splice(index, 1);
    if (index === activePartyIndex) {
      setActivePartyIndex(updated.length > 0 ? updated.length - 1 : 0);
    } else if (index < activePartyIndex) {
      setActivePartyIndex(prev => prev - 1);
    }
    setFormData({ ...formData, partyDetails: updated });
  };

  const addRespondentDetail = () => {
    setFormData((prev) => {
      const newRespondentDetails = [
        ...prev.respondentDetails,
        { party: "", advocate: "" },
      ];
      setActiveRespondentIndex(newRespondentDetails.length - 1);

      setTimeout(() => {
        if (respondentDetailsRefs.current[newRespondentDetails.length - 1]) {
          respondentDetailsRefs.current[newRespondentDetails.length - 1].focus();
        }
      }, 0);
      return {
        ...prev,
        respondentDetails: newRespondentDetails,
      };
    });
  };

  const removeRespondentDetail = (index) => {
    const updated = [...formData.respondentDetails];
    updated.splice(index, 1);
    if (index === activeRespondentIndex) {
      setActiveRespondentIndex(updated.length > 0 ? updated.length - 1 : 0);
    } else if (index < activeRespondentIndex) {
      setActiveRespondentIndex(prev => prev - 1);
    }
    setFormData({ ...formData, respondentDetails: updated });
  };

  const addActSection = () => {
    setFormData((prev) => {
      const newActsAndSections = [...prev.actsAndSections, { act: "", section: "" }];
      setActiveActSectionIndex(newActsAndSections.length - 1);

      setTimeout(() => {
        if (actsAndSectionsRefs.current[newActsAndSections.length - 1]) {
          actsAndSectionsRefs.current[newActsAndSections.length - 1].focus();
        }
      }, 0);
      return {
        ...prev,
        actsAndSections: newActsAndSections,
      };
    });
  };

  const removeActSection = (index) => {
    const updated = [...formData.actsAndSections];
    updated.splice(index, 1);
    if (index === activeActSectionIndex) {
      setActiveActSectionIndex(updated.length > 0 ? updated.length - 1 : 0);
    } else if (index < activeActSectionIndex) {
      setActiveActSectionIndex(prev => prev - 1);
    }
    setFormData({ ...formData, actsAndSections: updated });
  };



  // Fetch case details if in edit mode
  useEffect(() => {
    if (isEdit && courtRef) {
      showLoading("Loading case details...");
      getBothCourtCasesDetailsByCourtRef(courtRef)
        .then((response) => {
          if (response.data && response.data.case) {
            const caseData = response.data.case;
            setFormData(caseData);
            showToast("Case details loaded successfully!", "success");
          }
        })
        .catch((error) => {
          console.error("Error fetching case details:", error);
          showToast("Failed to load case details. Please try again.", "error");
        })
        .finally(() => {
          hideLoading();
        });
    }
  }, [isEdit, courtRef]);
  const handleChange = (e, section, index) => {
    const { name, value } = e.target;
    const updatedSection = [...formData[section]];

    updatedSection[index][name] = value;

    // Reset dist_code when state_code is changed
    if (name === "state_code") {
      updatedSection[index]["dist_code"] = "";
    }

    setFormData({ ...formData, [section]: updatedSection });
  };

  const handleNestedChange = (e, section) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [section]: { ...formData[section], [name]: value },
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // --- Validation Checks ---
    const partiesEmpty = !formData.parties || !formData.parties.trim();
    const courtRefEmpty = !formData.viewDetails.courtRef || !formData.viewDetails.courtRef.trim();
    const courtNameEmpty = !formData.courtName || !formData.courtName.trim();

    if (courtNameEmpty && partiesEmpty && courtRefEmpty) {
      showToast('Court Name, Parties and Court Reference are required.', 'error');
      return;
    }

    if ((partiesEmpty && courtRefEmpty) || (partiesEmpty && courtNameEmpty) || (courtNameEmpty && courtRefEmpty)) {
      const missing = [];
      if (courtNameEmpty) missing.push('Court Name');
      if (partiesEmpty) missing.push('Parties');
      if (courtRefEmpty) missing.push('Court Reference');
      showToast(`${missing.join(' and ')} ${missing.length > 1 ? 'are' : 'is'} required.`, 'error');
      return;
    }

    if (courtNameEmpty) {
      showToast('Court Name field is required.', 'error');
      return;
    }
    if (partiesEmpty) {
      showToast('Parties field is required.', 'error');
      return;
    }
    if (courtRefEmpty) {
      showToast('Court Reference field is required.', 'error');
      return;
    }

    showLoading("Processing...");

    try {

      const processedCaseStatus = { ...formData.caseStatus };
      const statusDateFields = ["First Hearing Date", "Decision Date", "Next Hearing Date"];

      statusDateFields.forEach(field => {
        if (processedCaseStatus[field]) {
          processedCaseStatus[field] = formatToReadableDate(processedCaseStatus[field]);
        }
      });

      // Filter empty keys in Case Status
      const filteredCaseStatus = {};
      Object.keys(processedCaseStatus).forEach(key => {
        if (processedCaseStatus[key] && processedCaseStatus[key].trim() !== '') {
          filteredCaseStatus[key] = processedCaseStatus[key];
        }
      });

      // --- B. Format Case Details Dates (Target: "DD-MM-YYYY") ---
      const processedCaseDetails = { ...formData.caseDetails };
      // Note: In your state, the key has a colon "Registration Date:"
      const detailsDateFields = ["Filing Date", "Registration Date:"];

      detailsDateFields.forEach(field => {
        if (processedCaseDetails[field]) {
          processedCaseDetails[field] = formatToDDMMYYYY(processedCaseDetails[field]);
        }
      });

      // --- C. Construct the Single Case Object ---
      const finalCaseObject = {
        court: formData.court, // Keep existing fields
        courtName: formData.courtName, // Ensure courtName is passed
        serialNumber: formData.serialNumber,
        caseTypeAndNumber: formData.caseTypeAndNumber,
        parties: formData.parties,
        advocates: formData.advocates,
        viewDetails: formData.viewDetails,
        caseDetails: processedCaseDetails, // Uses "DD-MM-YYYY" format
        caseStatus: filteredCaseStatus,    // Uses "14th August 2014" format
        partyDetails: formData.partyDetails,
        respondentDetails: formData.respondentDetails,
        actsAndSections: formData.actsAndSections,
        transferDetails: formData.transferDetails,
        historyData: formData.historyData,
        orders: formData.orders,
      };



      let response;

      if (isEdit && courtRef) {
        // --- EDIT MODE ---
        response = await UpdateDistrictManualCase(courtRef, finalCaseObject);
        showToast("Case updated successfully!", "success");
      } else {
        // --- CREATE/SUBMIT MODE ---
        const payload = {
          manualCreated: true,
          cases: [finalCaseObject],
        };
        response = await saveDistrictCourtCaseForm(payload);
        showToast("Case submitted successfully!", "success");
      }

      // Navigate back to cases after a short delay to show the toast
      setTimeout(() => {
        navigate("/home/cases");
      }, 1500);

    } catch (error) {
      console.error("Submission error:", error);
      showToast(
        "Failed to submit. Please check all fields and try again.",
        "error"
      );
    } finally {
      hideLoading();
    }
  };

  const handleFetchDetailsExternal = async (courtRefValue) => {
    if (!courtRefValue.trim()) {
      showToast("Please enter a Court Reference number first", "error");
      return;
    }

    setIsFetchingDetails(true);
    try {
      const response = await getdcdatabycourtRef(courtRefValue);

      // FIX: Check for response.data.success and response.data.data
      if (response.data && response.data.success && response.data.data) {
        // Also set the courtRef in form data
        setFormData((prev) => ({
          ...prev,
          viewDetails: {
            ...prev.viewDetails,
            courtRef: courtRefValue,
          },
        }));

        // FIX: Pass the entire response object, not just response.data
        populateFormWithFetchedData(response);

        const fetchedData = response.data.data;
        const missingFields = [];
        if (!fetchedData.courtName) missingFields.push("Court Name");
        if (!fetchedData.caseStatus || Object.keys(fetchedData.caseStatus).length === 0)
          missingFields.push("Case Status");

        if (missingFields.length > 0) {
          showToast(
            `Case details fetched, but ${missingFields.join(" and ")} could not be retrieved. Please fill manually.`,
            "warning"
          );
        } else {
          showToast(
            "Case details fetched and populated successfully!",
            "success"
          );
        }
      } else {
        showToast(
          "No case data found for the provided Court Reference",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching case details:", error);
      showToast(
        "Failed to fetch case details. Please check the Court Reference and try again.",
        "error"
      );
    } finally {
      setIsFetchingDetails(false);
    }
  };

  return (
    <>

      <div className="dc-case-form-wrapper">
        <div className="dc-case-form-header">
          <h1 className="dc-case-form-title">
            {isEdit ? "Edit District Court Case" : "District Court Case Form"}
          </h1>
          <p className="dc-case-form-subtitle">
            Enter comprehensive case details and information
          </p>
        </div>

        <div className="court-ref-fetch-section">
          <h3 className="fetch-section-title">Fetch Case Details</h3>
          <div className="fetch-input-group">
            <div className="fetch-input-wrapper">
              {/* <label className="fetch-label">Court Reference (CRN)</label> */}
              <input
                className="fetch-input"
                type="text"
                value={fetchCourtRef}
                onChange={(e) => {
                  // Remove all special characters, spaces, hyphens, dots, slashes, etc.
                  const formattedValue = e.target.value.replace(/[-\s.\\/]/g, '');
                  setFetchCourtRef(formattedValue);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !isFetchingDetails && fetchCourtRef.trim()) {
                    e.preventDefault();
                    handleFetchDetailsExternal(fetchCourtRef);
                  }
                }}
                placeholder="Enter court reference (CRN) to fetch details   E.g (GJAH220989552022)"
                ref={fetchInputRef}

              />
            </div>
            <button
              type="button"
              className="fetch-details-btn"
              onClick={() => handleFetchDetailsExternal(fetchCourtRef)}
              disabled={isFetchingDetails || !fetchCourtRef.trim()}
            >
              {isFetchingDetails ? "Fetching..." : "Fetch Details"}
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="dc-case-form" ref={formRef}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && e.target.type !== 'submit' && e.target.type !== 'button') {
              e.preventDefault();
              formRef.current && formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            }
          }}
        >
          {/* Basic Information Section */}
          <div className="dc-section">
            <h2 className="dc-section-title">Basic Information</h2>

            <div className="dc-field-group dc-subsection">
              <div className="dc-input-wrapper">
                <label className="dc-label">Court Name <span className="user-form-required">*</span></label>
                <input
                  className="dc-input dc-input-full"
                  name="courtName"
                  value={formData.courtName}
                  onChange={handleInputChange}
                  placeholder="Enter court name"
                />
              </div>
            </div>

            <div className="dc-field-row dc-subsection">
              <div className="dc-input-wrapper">
                <label className="dc-label">Serial Number</label>
                <input
                  className="dc-input"
                  name="serialNumber"
                  value={formData.serialNumber}
                  onChange={handleInputChange}
                  placeholder="Enter serial number"
                />
              </div>
              <div className="dc-input-wrapper">
                <label className="dc-label">Case Type & Number</label>
                <input
                  className="dc-input"
                  name="caseTypeAndNumber"
                  value={formData.caseTypeAndNumber}
                  onChange={handleInputChange}
                  placeholder="Enter case type and number"
                />
              </div>
            </div>

            <div className="dc-field-row dc-subsection">
              <div className="dc-input-wrapper">
                <label className="dc-label">Parties  <span className="user-form-required">*</span> </label>
                <input
                  className="dc-input"
                  name="parties"
                  value={formData.parties}
                  onChange={handleInputChange}
                  placeholder="Enter parties involved"
                />
              </div>
              <div className="dc-input-wrapper">
                <label className="dc-label">Advocates</label>
                <input
                  className="dc-input"
                  name="advocates"
                  value={formData.advocates}
                  onChange={handleInputChange}
                  placeholder="Enter advocates"
                />
              </div>
            </div>
          </div>

          {/* View Details Section */}
          <div className="dc-section">
            <h2 className="dc-section-title">View Details</h2>
            <div className="dc-subsection">
              <div className="dc-field-row">
                <div className="dc-input-wrapper">
                  <label className="dc-label">Case ID</label>
                  <input
                    className="dc-input"
                    type="text"
                    name="caseId"
                    value={formData.viewDetails.caseId}
                    onChange={(e) => handleNestedChange(e, "viewDetails")}
                    placeholder="Enter case ID"
                  />
                </div>
                {/* <div className="dc-input-wrapper">
                                    <label className="dc-label">Court Reference</label>
                                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                                        <input
                                            className="dc-input"
                                            type="text"
                                            name="courtRef"
                                            value={formData.viewDetails.courtRef}
                                            onChange={(e) => handleNestedChange(e, 'viewDetails')}
                                            placeholder="Enter court reference (CRN)"
                                            style={{ flex: 1 }}
                                        />
                                        <button
                                            type="button"
                                             className="fetch-details-btn"
                                            onClick={handleFetchDetails}
                                            disabled={isFetchingDetails || !formData.viewDetails.courtRef.trim()}
                                            style={{
                                                whiteSpace: 'nowrap',
                                                minWidth: '120px',
                                                opacity: (!formData.viewDetails.courtRef.trim() || isFetchingDetails) ? 0.6 : 1
                                            }}
                                        >
                                            {isFetchingDetails ? 'Fetching...' : 'Fetch Details'}
                                        </button>
                                    </div>
                                </div> */}
                <div className="dc-input-wrapper">
                  <label className="dc-label">Court Reference  <span className="user-form-required">*</span></label>
                  <input
                    className="dc-input"
                    type="text"
                    name="courtRef"
                    value={formData.viewDetails.courtRef}
                    onChange={(e) => handleNestedChange(e, "viewDetails")}
                    placeholder="Enter court reference (CRN)"
                  />
                </div>
                <div className="dc-input-wrapper">
                  <label className="dc-label">Index</label>
                  <input
                    className="dc-input"
                    type="text"
                    name="index"
                    value={formData.viewDetails.index}
                    onChange={(e) => handleNestedChange(e, "viewDetails")}
                    placeholder="Enter index"
                  />
                </div>
              </div>

              <div className="dc-field-row">
                <div className="dc-input-wrapper">
                  <label className="dc-label">Hide Party</label>
                  <input
                    className="dc-input"
                    type="text"
                    name="hideparty"
                    value={formData.viewDetails.hideparty}
                    onChange={(e) => handleNestedChange(e, "viewDetails")}
                    placeholder="Hide party info"
                  />
                </div>
                <div className="dc-input-wrapper">
                  <label className="dc-label">Case Status Search Type</label>
                  <input
                    className="dc-input"
                    type="text"
                    name="caseStatusSearchType"
                    value={formData.viewDetails.caseStatusSearchType}
                    onChange={(e) => handleNestedChange(e, "viewDetails")}
                    placeholder="Search type"
                  />
                </div>
              </div>

              {/* <div className="dc-field-row">
                                <div className="dc-input-wrapper">
                                    <label className="dc-label">State Code</label>
                                    <select
                                        className="dc-input"
                                        name="state_code"
                                        value={formData.viewDetails.state_code}
                                        onChange={(e) => handleNestedChange(e, 'viewDetails')}
                                    >
                                        <option value="">Select State</option>
                                        {stateOptions.map((state) => (
                                            <option key={state.code} value={state.code}>
                                                {state.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="dc-input-wrapper">
                                    <label className="dc-label">District Code</label>
                                    <select
                                        className="dc-input"
                                        name="dist_code"
                                        value={formData.viewDetails.dist_code}
                                        onChange={(e) => handleNestedChange(e, 'viewDetails')}
                                        disabled={!formData.viewDetails.state_code}
                                    >
                                        <option value="">Select District</option>
                                        {(districtOptionsMap[formData.viewDetails.state_code] || []).map((dist) => (
                                            <option key={dist.code} value={dist.code}>
                                                {dist.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="dc-input-wrapper">
                                    <label className="dc-label">Complex Code</label>
                                    <select
                                        className="dc-input"
                                        name="complex_code"
                                        value={formData.viewDetails.complex_code}
                                        onChange={(e) => handleNestedChange(e, 'viewDetails')}
                                        disabled={!formData.viewDetails.dist_code}
                                    >
                                        <option value="">Select Complex</option>
                                        {(complexOptionsMap[formData.viewDetails.dist_code] || []).map((complex) => (
                                            <option key={complex.code} value={complex.code}>
                                                {complex.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div> */}

              <div className="dc-field-group">
                <div className="dc-input-wrapper">
                  <label className="dc-label">Type</label>
                  <input
                    className="dc-input"
                    type="text"
                    name="type"
                    value={formData.viewDetails.type}
                    onChange={(e) => handleNestedChange(e, "viewDetails")}
                    placeholder="Enter type"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Case Status Section */}
          <div className="dc-section">
            <h2 className="dc-section-title">Case Status</h2>
            <div className="dc-field-row dc-subsection">
              <div className="dc-input-wrapper">
                <label className="dc-label">First Hearing Date</label>
                <input
                  className="dc-input dc-input-date"
                  type="date"
                  name="First Hearing Date"
                  value={formData.caseStatus["First Hearing Date"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseStatus: {
                        ...prev.caseStatus,
                        ["First Hearing Date"]: e.target.value,
                      },
                    }))
                  }
                />
              </div>
              <div className="dc-input-wrapper">
                <label className="dc-label">Next Hearing Date</label>
                <input
                  className="dc-input dc-input-date"
                  type="date"
                  name="Next Hearing Date"
                  value={formData.caseStatus["Next Hearing Date"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseStatus: {
                        ...prev.caseStatus,
                        ["Next Hearing Date"]: e.target.value,
                      },
                    }))
                  }
                />
              </div>
            </div>

            <div className="dc-field-row dc-subsection">
              <div className="dc-input-wrapper">
                <label className="dc-label">Decision Date</label>
                <input
                  className="dc-input dc-input-date"
                  type="date"
                  name="Decision Date"
                  value={formData.caseStatus["Decision Date"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseStatus: {
                        ...prev.caseStatus,
                        ["Decision Date"]: e.target.value,
                      },
                    }))
                  }
                />
              </div>
              <div className="dc-input-wrapper">
                <label className="dc-label">Case Stage</label>
                <select
                  className="dc-input"
                  name="Case Status"
                  value={formData.caseStatus["Case Status"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseStatus: {
                        ...prev.caseStatus,
                        ["Case Status"]: e.target.value,
                      },
                    }))
                  }
                >
                  <option value="">Select case status</option>
                  <option value="Pending">Pending</option>
                  <option value="Disposed">Disposed</option>
                </select>
              </div>
              <div className="dc-input-wrapper">
                <label className="dc-label">Nature of Disposal</label>
                <select
                  className="dc-input"
                  name="Nature of Disposal"
                  value={formData.caseStatus["Nature of Disposal"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseStatus: {
                        ...prev.caseStatus,
                        ["Nature of Disposal"]: e.target.value,
                      },
                    }))
                  }
                >
                  <option value="">Select nature of disposal</option>
                  <option value="Contested--ALLOWED">Contested--ALLOWED</option>
                  <option value="Uncontested--ALLOWED">
                    Uncontested--ALLOWED
                  </option>
                  <option value="Contested--JUDGMENT BY ACQUITTAL">
                    Contested--JUDGMENT BY ACQUITTAL
                  </option>
                  <option value="Contested--REJECTED">
                    Contested--REJECTED
                  </option>
                </select>
              </div>

              <div className="dc-input-wrapper">
                <label className="dc-label">Court Number and Judge</label>
                <input
                  className="dc-input"
                  type="text"
                  name="Court Number and Judge"
                  value={formData.caseStatus["Court Number and Judge"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseStatus: {
                        ...prev.caseStatus,
                        ["Court Number and Judge"]: e.target.value,
                      },
                    }))
                  }
                  placeholder="Court number and judge"
                />
              </div>
            </div>
          </div>

          {/* Case Details Section */}
          <div className="dc-section">
            <h2 className="dc-section-title">Case Details</h2>
            <div className="dc-field-row dc-subsection">
              <div className="dc-input-wrapper ">
                <label className="dc-label">Case Type</label>
                <input
                  className="dc-input"
                  type="text"
                  name="Case Type"
                  value={formData.caseDetails["Case Type"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseDetails: {
                        ...prev.caseDetails,
                        ["Case Type"]: e.target.value,
                      },
                    }))
                  }
                  placeholder="Enter case type"
                />
              </div>
              <div className="dc-input-wrapper">
                <label className="dc-label">Filing Number</label>
                <input
                  className="dc-input"
                  type="text"
                  name="Filing Number"
                  value={formData.caseDetails["Filing Number"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseDetails: {
                        ...prev.caseDetails,
                        ["Filing Number"]: e.target.value,
                      },
                    }))
                  }
                  placeholder="Enter filing number"
                />
              </div>
              <div className="dc-input-wrapper">
                <label className="dc-label">Filing Date</label>
                <input
                  className="dc-input dc-input-date"
                  type="date"
                  name="Filing Date"
                  value={formData.caseDetails["Filing Date"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseDetails: {
                        ...prev.caseDetails,
                        ["Filing Date"]: e.target.value,
                      },
                    }))
                  }
                />
              </div>
              <div className="dc-input-wrapper">
                <label className="dc-label">Registration No:</label>
                <input
                  className="dc-input"
                  type="text"
                  name="Registration Number"
                  value={formData.caseDetails["Registration Number"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseDetails: {
                        ...prev.caseDetails,
                        ["Registration Number"]: e.target.value,
                      },
                    }))
                  }
                  placeholder="Enter Registration Number"
                />
              </div>
              <div className="dc-input-wrapper">
                <label className="dc-label">Registration Date</label>
                <input
                  className="dc-input dc-input-date"
                  type="date"
                  name="Registration Date:"
                  value={formData.caseDetails["Registration Date:"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseDetails: {
                        ...prev.caseDetails,
                        ["Registration Date:"]: e.target.value,
                      },
                    }))
                  }
                />
              </div>
              <div className="dc-input-wrapper">
                <label className="dc-label">CNR Number</label>
                <input
                  className="dc-input"
                  type="text"
                  name="CNR Number"
                  value={formData.caseDetails["CNR Number"]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      caseDetails: {
                        ...prev.caseDetails,
                        ["CNR Number"]: e.target.value,
                      },
                    }))
                  }
                  placeholder="Enter CNR Number"
                />
              </div>
            </div>
          </div>

          {/* Party Details Section */}
          <div className="dc-section">
            <h2 className="dc-section-title">Party Details</h2>
            {formData.partyDetails.map((item, index) => {
              const isExpanded = index === activePartyIndex;
              const hasData = item && item.trim() !== "";

              return (
                <div className={`dc-subsection ${!isExpanded && hasData ? 'collapsed' : ''}`} key={index}>
                  {!isExpanded && hasData ? (
                    <div className="summary-view">
                      <div className="summary-details">
                        <span className="summary-value">{item}</span>
                      </div>
                      <div className="summary-actions">
                        <button type="button" className="edit-btn" onClick={() => setActivePartyIndex(index)}>Edit</button>
                        <button type="button" className="court-remove-case" onClick={() => removePartyDetail(index)}>Remove</button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="dc-input-wrapper">
                        <label className="dc-label">Party Detail {index + 1}</label>
                        <textarea
                          ref={(el) => (partyDetailsRefs.current[index] = el)}
                          className="dc-textarea"
                          value={item}
                          onChange={(e) => {
                            const updated = [...formData.partyDetails];
                            updated[index] = e.target.value;
                            setFormData({ ...formData, partyDetails: updated });
                          }}
                          placeholder={`Enter party detail ${index + 1}`}
                          rows="3"
                        />
                        <div className="rem-div-btn">
                          <button
                            type="button"
                            className="court-remove-case"
                            onClick={() => removePartyDetail(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addPartyDetail}
              >
                + Party Detail
              </button>
            </div>
          </div>

          {/* Respondent Details Section */}
          <div className="dc-section">
            {/* <h2 className="dc-section-title">Respondent Details</h2>
            {formData.respondentDetails.map((item, index) => (
              <div className="dc-subsection" key={index}>
                <div className="dc-field-row">
                  <div className="dc-input-wrapper">
                    <label className="dc-label">Party</label>
                    <input
                      ref={(el) => (respondentDetailsRefs.current[index] = el)}
                      className="dc-input"
                      type="text"
                      value={item.party}
                      onChange={(e) => {
                        const updated = [...formData.respondentDetails];
                        updated[index].party = e.target.value;
                        setFormData({ ...formData, respondentDetails: updated });
                      }}
                      placeholder="Enter party name"
                    />
                  </div>
                  <div className="dc-input-wrapper">
                    <label className="dc-label">Advocate</label>
                    <input
                      className="dc-input"
                      type="text"
                      value={item.advocate}
                      onChange={(e) => {
                        const updated = [...formData.respondentDetails];
                        updated[index].advocate = e.target.value;
                        setFormData({ ...formData, respondentDetails: updated });
                      }}
                      placeholder="Enter advocate name"
                    />
                  </div>
                </div>
                <div className="dc-field-actions">
                  <div className="rem-div-btn">
                    <button
                      type="button"
                      className="court-remove-case"
                      //style={{ marginTop: "0.5rem", alignSelf: "flex-start" }}
                      onClick={() => removeRespondentDetail(index)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addRespondentDetail}
              >
                + Respondent Detail
              </button>
            </div> */}

            <h2 className="dc-section-title">Respondent Details</h2>
            {formData.respondentDetails.map((item, index) => {
              const isExpanded = index === activeRespondentIndex;
              const hasData = item.party || item.advocate;

              return (
                <div className={`dc-subsection ${!isExpanded && hasData ? 'collapsed' : ''}`} key={index}>
                  {!isExpanded && hasData ? (
                    <div className="summary-view">
                      <div className="summary-details">
                        <div className="summary-item"><span className="summary-label">Party:</span><span className="summary-value">{item.party || 'N/A'}</span></div>
                        <div className="summary-item"><span className="summary-label">Advocate:</span><span className="summary-value">{item.advocate || 'N/A'}</span></div>
                      </div>
                      <div className="summary-actions">
                        <button type="button" className="edit-btn" onClick={() => setActiveRespondentIndex(index)}>Edit</button>
                        <button type="button" className="court-remove-case" onClick={() => removeRespondentDetail(index)}>Remove</button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="dc-field-row">
                        <div className="dc-input-wrapper">
                          <label className="dc-label">Party</label>
                          <input
                            ref={(el) => (respondentDetailsRefs.current[index] = el)}
                            className="dc-input"
                            type="text"
                            value={item.party}
                            onChange={(e) => {
                              const updated = [...formData.respondentDetails];
                              updated[index].party = e.target.value;
                              setFormData({ ...formData, respondentDetails: updated });
                            }}
                            placeholder="Enter party name"
                          />
                        </div>
                        <div className="dc-input-wrapper">
                          <label className="dc-label">Advocate</label>
                          <input
                            className="dc-input"
                            type="text"
                            value={item.advocate}
                            onChange={(e) => {
                              const updated = [...formData.respondentDetails];
                              updated[index].advocate = e.target.value;
                              setFormData({ ...formData, respondentDetails: updated });
                            }}
                            placeholder="Enter advocate name"
                          />
                        </div>
                      </div>
                      <div className="rem-div-btn">
                        <button
                          type="button"
                          className="court-remove-case"
                          onClick={() => removeRespondentDetail(index)}
                        >
                          Remove
                        </button>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addRespondentDetail}
              >
                + Respondent Detail
              </button>
            </div>
          </div>

          {/* Acts and Sections */}
          <div className="dc-section">
            {/* <h2 className="dc-section-title">Acts and Sections</h2>
            {formData.actsAndSections.map((item, index) => (
              <div className="dc-subsection" key={index}>
                <div className="dc-field-row">
                  <div className="dc-input-wrapper">
                    <label className="dc-label">Act</label>
                    <input
                      ref={(el) => (actsAndSectionsRefs.current[index] = el)}
                      className="dc-input"
                      type="text"
                      value={item.act}
                      onChange={(e) => {
                        const updated = [...formData.actsAndSections];
                        updated[index].act = e.target.value;
                        setFormData({ ...formData, actsAndSections: updated });
                      }}
                      placeholder="Enter act name"
                    />
                  </div>
                  <div className="dc-input-wrapper">
                    <label className="dc-label">Section</label>
                    <input
                      className="dc-input"
                      type="text"
                      value={item.section}
                      onChange={(e) => {
                        const updated = [...formData.actsAndSections];
                        updated[index].section = e.target.value;
                        setFormData({ ...formData, actsAndSections: updated });
                      }}
                      placeholder="Enter section number"
                    />
                  </div>
                </div>
                <div className="dc-field-actions">
                  <div className="rem-div-btn">
                    <button
                      type="button"
                      className="court-remove-case"
                      onClick={() => removeActSection(index)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addActSection}
              >
                + Act & Section
              </button>
            </div> */}

            <h2 className="dc-section-title">Acts and Sections</h2>
            {formData.actsAndSections.map((item, index) => {
              const isExpanded = index === activeActSectionIndex;
              const hasData = item.act || item.section;

              return (
                <div className={`dc-subsection ${!isExpanded && hasData ? 'collapsed' : ''}`} key={index}>
                  {!isExpanded && hasData ? (
                    <div className="summary-view">
                      <div className="summary-details">
                        <div className="summary-item"><span className="summary-label">Act:</span><span className="summary-value">{item.act || 'N/A'}</span></div>
                        <div className="summary-item"><span className="summary-label">Section:</span><span className="summary-value">{item.section || 'N/A'}</span></div>
                      </div>
                      <div className="summary-actions">
                        <button type="button" className="edit-btn" onClick={() => setActiveActSectionIndex(index)}>Edit</button>
                        <button type="button" className="court-remove-case" onClick={() => removeActSection(index)}>Remove</button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="dc-field-row">
                        <div className="dc-input-wrapper">
                          <label className="dc-label">Act</label>
                          <input
                            ref={(el) => (actsAndSectionsRefs.current[index] = el)}
                            className="dc-input"
                            type="text"
                            value={item.act}
                            onChange={(e) => {
                              const updated = [...formData.actsAndSections];
                              updated[index].act = e.target.value;
                              setFormData({ ...formData, actsAndSections: updated });
                            }}
                            placeholder="Enter act name"
                          />
                        </div>
                        <div className="dc-input-wrapper">
                          <label className="dc-label">Section</label>
                          <input
                            className="dc-input"
                            type="text"
                            value={item.section}
                            onChange={(e) => {
                              const updated = [...formData.actsAndSections];
                              updated[index].section = e.target.value;
                              setFormData({ ...formData, actsAndSections: updated });
                            }}
                            placeholder="Enter section number"
                          />
                        </div>
                      </div>
                      <div className="rem-div-btn">
                        <button
                          type="button"
                          className="court-remove-case"
                          onClick={() => removeActSection(index)}
                        >
                          Remove
                        </button>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addActSection}
              >
                + Act & Section
              </button>
            </div>
          </div>

          {/* <div className="dc-section">
            <h2 className="dc-section-title">Transfer Details</h2>

            {formData.transferDetails.length === 0 ? (
              <div className="dc-empty-state">
                <p className="dc-empty-text">No transfer details available</p>
              </div>
            ) : (
              formData.transferDetails.map((item, index) => (
                <div className="dc-subsection" key={index}>
                  <div className="dc-field-row">
                    <div className="dc-input-wrapper">
                      <label className="dc-label">Registeration Number</label>
                      <input
                        ref={(el) => (transferDetailsRefs.current[index] = el)}
                        className="dc-input"
                        type="text"
                        value={item["Registeration Number"]}
                        onChange={(e) =>
                          handleTransferChange(e, index, "Registeration Number")
                        }
                        placeholder="Enter Registeration Number"
                      />
                    </div>

                    <div className="dc-input-wrapper">
                      <label className="dc-label">
                        From Court No and Judge
                      </label>
                      <input
                        className="dc-input"
                        type="text"
                        value={item["From Court Number and Judge"]}
                        onChange={(e) =>
                          handleTransferChange(
                            e,
                            index,
                            "From Court Number and Judge"
                          )
                        }
                        placeholder="Enter From Court and Judge"
                      />
                    </div>

                    <div className="dc-input-wrapper">
                      <label className="dc-label">
                        To Court Number and Judge
                      </label>
                      <input
                        className="dc-input"
                        type="text"
                        value={item["To Court Number and Judge"]}
                        onChange={(e) =>
                          handleTransferChange(
                            e,
                            index,
                            "To Court Number and Judge"
                          )
                        }
                        placeholder="Enter To Court and Judge"
                      />
                    </div>

                    <div className="dc-input-wrapper">
                      <label className="dc-label">Transfer Date</label>
                      <input
                        className="dc-input dc-input-date"
                        type="date"
                        value={item["Transfer Date"]}
                        onChange={(e) =>
                          handleTransferChange(e, index, "Transfer Date")
                        }
                      />
                    </div>
                  </div>

                  <div className="dc-field-actions">
                    <div className="rem-div-btn">
                      <button
                        type="button"
                        className="court-remove-case"
                        onClick={() => removeTransfer(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addTransfer}
              >
                + Transfer Detail
              </button>
            </div>
          </div> */}

          <div className="dc-section">
            <h2 className="dc-section-title">Transfer Details</h2>
            {formData.transferDetails.length === 0 ? (
              <div className="dc-empty-state">
                <p className="dc-empty-text">No transfer details available</p>
              </div>
            ) : (
              formData.transferDetails.map((item, index) => {
                const isExpanded = index === activeTransferIndex;
                const hasData = item["Registeration Number"] || item["Transfer Date"];

                return (
                  <div className={`dc-subsection ${!isExpanded && hasData ? 'collapsed' : ''}`} key={index}>
                    {!isExpanded && hasData ? (
                      <div className="summary-view">
                        <div className="summary-details">
                          <div className="summary-item">
                            <span className="summary-label">Reg No:</span>
                            <span className="summary-value">{item["Registeration Number"] || 'N/A'}</span>
                          </div>
                          <div className="summary-item">
                            <span className="summary-label">Date:</span>
                            <span className="summary-value">{item["Transfer Date"] || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="summary-actions">
                          <button type="button" className="edit-btn" onClick={() => setActiveTransferIndex(index)}>Edit</button>
                          <button type="button" className="court-remove-case" onClick={() => removeTransfer(index)}>Remove</button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="dc-field-row">
                          <div className="dc-input-wrapper">
                            <label className="dc-label">Registeration Number</label>
                            <input
                              ref={(el) => (transferDetailsRefs.current[index] = el)}
                              className="dc-input"
                              type="text"
                              value={item["Registeration Number"]}
                              onChange={(e) => handleTransferChange(e, index, "Registeration Number")}
                              placeholder="Enter Registeration Number"
                            />
                          </div>
                          <div className="dc-input-wrapper">
                            <label className="dc-label">Transfer Date</label>
                            <input
                              className="dc-input dc-input-date"
                              type="date"
                              value={item["Transfer Date"]}
                              onChange={(e) => handleTransferChange(e, index, "Transfer Date")}
                            />
                          </div>
                        </div>
                        <div className="dc-field-row">
                          <div className="dc-input-wrapper">
                            <label className="dc-label">From Court No and Judge</label>
                            <input
                              className="dc-input"
                              type="text"
                              value={item["From Court Number and Judge"]}
                              onChange={(e) => handleTransferChange(e, index, "From Court Number and Judge")}
                              placeholder="Enter From Court and Judge"
                            />
                          </div>
                          <div className="dc-input-wrapper">
                            <label className="dc-label">To Court Number and Judge</label>
                            <input
                              className="dc-input"
                              type="text"
                              value={item["To Court Number and Judge"]}
                              onChange={(e) => handleTransferChange(e, index, "To Court Number and Judge")}
                              placeholder="Enter To Court and Judge"
                            />
                          </div>
                        </div>
                        <div className="rem-div-btn">
                          <button
                            type="button"
                            className="court-remove-case"
                            onClick={() => removeTransfer(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                );
              })
            )}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addTransfer}
              >
                + Transfer Detail
              </button>
            </div>
          </div>

          {/* <div className="dc-section">
            <h2 className="dc-section-title">History Data</h2>

            {formData.historyData.map((item, index) => (
              <div className="dc-subsection" key={index}>
                <div className="dc-field-row">
                  <div className="dc-input-wrapper">
                    <label className="dc-label">Judge</label>
                    <input
                      ref={(el) => (historyDataRefs.current[index] = el)}
                      className="dc-input"
                      type="text"
                      name="judge"
                      value={item.judge}
                      onChange={(e) => handleHistoryChange(e, index)}
                      placeholder="Enter judge name"
                    />
                  </div>

                  <div className="dc-input-wrapper">
                    <label className="dc-label">Business On Date</label>
                    <input
                      className="dc-input dc-input-date"
                      type="date"
                      name="businessOnDate"
                      value={item.businessOnDate}
                      onChange={(e) => handleHistoryChange(e, index)}
                    />
                  </div>
                </div>

                <div className="dc-field-row">
                  <div className="dc-input-wrapper">
                    <label className="dc-label">Hearing Date</label>
                    <input
                      className="dc-input dc-input-date"
                      type="date"
                      name="hearingDate"
                      value={item.hearingDate}
                      onChange={(e) => handleHistoryChange(e, index)}
                    />
                  </div>

                  <div className="dc-input-wrapper">
                    <label className="dc-label">Purpose of Hearing</label>
                    <input
                      className="dc-input"
                      type="text"
                      name="purposeOfHearing"
                      value={item.purposeOfHearing}
                      onChange={(e) => handleHistoryChange(e, index)}
                      placeholder="Enter purpose of hearing"
                    />
                  </div>
                </div>

                <div className="dc-field-actions">
                  <div className="rem-div-btn">
                    <button
                      type="button"
                      className="court-remove-case"
                      onClick={() => removeHistoryRow(index)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addHistoryRow}
              >
                + History Data
              </button>
            </div>
          </div> */}

          <div className="dc-section">
            <h2 className="dc-section-title">History Data</h2>
            {formData.historyData.length === 0 ? (
              <div className="dc-empty-state">
                <p className="dc-empty-text">No history data available</p>
              </div>
            ) : (
              formData.historyData.map((item, index) => {
                const isExpanded = index === activeHistoryIndex;
                const hasData = item.judge || item.hearingDate || item.purposeOfHearing;

                return (
                  <div className={`dc-subsection ${!isExpanded && hasData ? 'collapsed' : ''}`} key={index}>
                    {!isExpanded && hasData ? (
                      <div className="summary-view">
                        <div className="summary-details">
                          <div className="summary-item">
                            <span className="summary-label">Purpose:</span>
                            <span className="summary-value">{item.purposeOfHearing || 'N/A'}</span>
                          </div>
                          <div className="summary-item">
                            <span className="summary-label">Date:</span>
                            <span className="summary-value">{item.hearingDate || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="summary-actions">
                          <button type="button" className="edit-btn" onClick={() => setActiveHistoryIndex(index)}>Edit</button>
                          <button type="button" className="court-remove-case" onClick={() => removeHistoryRow(index)}>Remove</button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="dc-field-row">
                          <div className="dc-input-wrapper">
                            <label className="dc-label">Judge</label>
                            <input
                              ref={(el) => (historyDataRefs.current[index] = el)}
                              className="dc-input"
                              type="text"
                              name="judge"
                              value={item.judge}
                              onChange={(e) => handleHistoryChange(e, index)}
                              placeholder="Enter judge name"
                            />
                          </div>
                          <div className="dc-input-wrapper">
                            <label className="dc-label">Business On Date</label>
                            <input
                              className="dc-input dc-input-date"
                              type="date"
                              name="businessOnDate"
                              value={item.businessOnDate}
                              onChange={(e) => handleHistoryChange(e, index)}
                            />
                          </div>
                        </div>
                        <div className="dc-field-row">
                          <div className="dc-input-wrapper">
                            <label className="dc-label">Hearing Date</label>
                            <input
                              className="dc-input dc-input-date"
                              type="date"
                              name="hearingDate"
                              value={item.hearingDate}
                              onChange={(e) => handleHistoryChange(e, index)}
                            />
                          </div>
                          <div className="dc-input-wrapper">
                            <label className="dc-label">Purpose of Hearing</label>
                            <input
                              className="dc-input"
                              type="text"
                              name="purposeOfHearing"
                              value={item.purposeOfHearing}
                              onChange={(e) => handleHistoryChange(e, index)}
                              placeholder="Enter purpose of hearing"
                            />
                          </div>
                        </div>
                        <div className="rem-div-btn">
                          <button
                            type="button"
                            className="court-remove-case"
                            onClick={() => removeHistoryRow(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                );
              })
            )}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addHistoryRow}
              >
                + History Data
              </button>
            </div>
          </div>



          {/* 
          <div className="dc-section">
            <h2 className="dc-section-title">Orders</h2>

            {formData.orders.length === 0 ? (
              <div className="dc-empty-state">
                <p className="dc-empty-text">No orders available.</p>
              </div>
            ) : (
              formData.orders.map((item, index) => {
                const orderKey = `order_${index}`;
                const isUploading = uploadingOrders[orderKey];
                const uploadProgress = uploadProgressOrders[orderKey] || 0;

                return (
                  <div className="dc-subsection" key={index}>
                    <div className="dc-field-row">
                      <div className="dc-input-wrapper">
                        <label className="dc-label">Order Number</label>
                        <input
                          ref={(el) => (ordersRefs.current[index] = el)}
                          className="dc-input"
                          type="text"
                          name="orderNumber"
                          value={item.orderNumber}
                          onChange={(e) => handleOrderChange(e, index)}
                          placeholder="Enter order number"
                        />
                      </div>
                      <div className="dc-input-wrapper">
                        <label className="dc-label">Order Date</label>
                        <input
                          className="dc-input dc-input-date"
                          type="date"
                          name="orderDate"
                          value={item.orderDate}
                          onChange={(e) => handleOrderChange(e, index)}
                        />
                      </div>
                      <div className="dc-input-wrapper">
                        <label className="dc-label">Order Title</label>
                        <input
                          className="dc-input"
                          type="text"
                          name="orderTitle"
                          value={item.orderTitle}
                          onChange={(e) => handleOrderChange(e, index)}
                          placeholder="Enter order title"
                        />
                      </div>
                    </div>

                    <div className="dc-field-row">

                    </div>

                    <div className="dc-field-row">
                      <div className="dc-input-wrapper">
                        <label className="dc-label">Order PDF File</label>
                        <input
                          type="file"
                          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.mp4,.avi,.mov"
                          onChange={(e) => handleOrderFileChange(e, index)}
                          style={{ display: 'none' }}
                          id={`orderFile_${index}`}
                          disabled={isUploading}
                        />

                        {!item.orderPdfLink && !isUploading && (
                          <div
                            className="upload-placeholder"
                            onClick={() => document.getElementById(`orderFile_${index}`).click()}
                            style={{
                              border: '2px dashed #e2e8f0',
                              borderRadius: '0.375rem',
                              padding: '1rem',
                              textAlign: 'center',
                              cursor: 'pointer',
                              background: '#fafafa'
                            }}
                          >
                            <span style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                              Click to upload order file
                            </span>
                          </div>
                        )}

                        {isUploading && (
                          <div className="upload-progress">
                            <div className="progress-bar" style={{
                              width: '100%',
                              height: '8px',
                              backgroundColor: '#e5e7eb',
                              borderRadius: '4px',
                              overflow: 'hidden',
                              marginBottom: '0.5rem'
                            }}>
                              <div
                                className="progress-fill"
                                style={{
                                  width: `${uploadProgress}%`,
                                  height: '100%',
                                  backgroundColor: '#3b82f6',
                                  transition: 'width 0.3s ease'
                                }}
                              />
                            </div>
                            <p style={{ margin: 0, fontSize: '0.875rem', color: '#6b7280' }}>
                              {uploadProgress}% uploaded
                            </p>
                          </div>
                        )}

                        {item.orderPdfLink && !isUploading && (
                          <div className="uploaded-file" style={{
                            marginTop: '1rem',
                            padding: '0.75rem 1rem',
                            backgroundColor: '#f0f9ff',
                            border: '1px solid #bae6fd',
                            borderRadius: '0.375rem',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: '1rem'
                          }}>
                            <a
                              href={`${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${item.orderPdfLink}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: '#0369a1',
                                textDecoration: 'none',
                                fontWeight: '500',
                                fontSize: '0.875rem',
                                flex: 1
                              }}
                            >
                              View Uploaded Order File
                            </a>
                            <button
                              type="button"
                              onClick={() => handleRemoveOrderFile(index)}
                              style={{
                                backgroundColor: '#ef4444',
                                color: 'white',
                                border: 'none',
                                padding: '0.375rem 0.75rem',
                                borderRadius: '0.25rem',
                                fontSize: '0.75rem',
                                fontWeight: '500',
                                cursor: 'pointer'
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="dc-field-actions">
                      <div className="rem-div-btn">
                        <button
                          type="button"
                          className="court-remove-case"
                          onClick={() => removeOrder(index)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addOrder}
              >
                + Order
              </button>
            </div>

            <div className="dc-submit-section-form" ref={submitSectionRef}>
              <button className="submit-btn" type="submit" disabled={isLoading}>
                <span>{isLoading ? 'Processing...' : (isEdit ? 'Update District Court Case' : 'Submit District Court Case')}</span>
              </button>
            </div>

          </div> */}
          <div className="dc-section">
            <h2 className="dc-section-title">Orders</h2>
            {formData.orders.length === 0 ? (
              <div className="dc-empty-state">
                <p className="dc-empty-text">No orders available.</p>
              </div>
            ) : (
              formData.orders.map((item, index) => {
                const isExpanded = index === activeOrderIndex;
                const hasData = item.orderNumber || item.orderDate || item.orderTitle;
                const orderKey = `order_${index}`;
                const isUploading = uploadingOrders[orderKey];
                const uploadProgress = uploadProgressOrders[orderKey] || 0;

                return (
                  <div className={`dc-subsection ${!isExpanded && hasData ? 'collapsed' : ''}`} key={index}>
                    {!isExpanded && hasData ? (
                      <div className="summary-view">
                        <div className="summary-details">
                          <div className="summary-item">
                            <span className="summary-label">Order No:</span>
                            <span className="summary-value">{item.orderNumber || 'N/A'}</span>
                          </div>
                          <div className="summary-item">
                            <span className="summary-label">Date:</span>
                            <span className="summary-value">{item.orderDate || 'N/A'}</span>
                          </div>
                        </div>
                        <div className="summary-actions">
                          <button type="button" className="edit-btn" onClick={() => setActiveOrderIndex(index)}>Edit</button>
                          <button type="button" className="court-remove-case" onClick={() => removeOrder(index)}>Remove</button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="dc-field-row">
                          <div className="dc-input-wrapper">
                            <label className="dc-label">Order Number</label>
                            <input
                              ref={(el) => (ordersRefs.current[index] = el)}
                              className="dc-input"
                              type="text"
                              name="orderNumber"
                              value={item.orderNumber}
                              onChange={(e) => handleOrderChange(e, index)}
                              placeholder="Enter order number"
                            />
                          </div>
                          <div className="dc-input-wrapper">
                            <label className="dc-label">Order Date</label>
                            <input
                              className="dc-input dc-input-date"
                              type="date"
                              name="orderDate"
                              value={item.orderDate}
                              onChange={(e) => handleOrderChange(e, index)}
                            />
                          </div>
                          <div className="dc-input-wrapper">
                            <label className="dc-label">Order Title</label>
                            <input
                              className="dc-input"
                              type="text"
                              name="orderTitle"
                              value={item.orderTitle}
                              onChange={(e) => handleOrderChange(e, index)}
                              placeholder="Enter order title"
                            />
                          </div>
                        </div>

                        <div className="dc-field-row">
                          <div className="dc-input-wrapper">
                            <label className="dc-label">Order PDF File</label>
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.mp4,.avi,.mov"
                              onChange={(e) => handleOrderFileChange(e, index)}
                              style={{ display: 'none' }}
                              id={`orderFile_${index}`}
                              disabled={isUploading}
                            />
                            {!item.orderPdfLink && !isUploading && (
                              <div
                                className="upload-placeholder"
                                onClick={() => document.getElementById(`orderFile_${index}`).click()}
                                style={{
                                  border: '2px dashed #e2e8f0',
                                  borderRadius: '0.375rem',
                                  padding: '1rem',
                                  textAlign: 'center',
                                  cursor: 'pointer',
                                  background: '#fafafa'
                                }}
                              >
                                <span style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                                  Click to upload order file
                                </span>
                              </div>
                            )}
                            {isUploading && (
                              <div className="upload-progress">
                                <div className="progress-bar" style={{
                                  width: '100%',
                                  height: '8px',
                                  backgroundColor: '#e5e7eb',
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  marginBottom: '0.5rem'
                                }}>
                                  <div
                                    className="progress-fill"
                                    style={{
                                      width: `${uploadProgress}%`,
                                      height: '100%',
                                      backgroundColor: '#3b82f6',
                                      transition: 'width 0.3s ease'
                                    }}
                                  />
                                </div>
                                <p style={{ margin: 0, fontSize: '0.875rem', color: '#6b7280' }}>
                                  {uploadProgress}% uploaded
                                </p>
                              </div>
                            )}
                            {item.orderPdfLink && !isUploading && (
                              <div className="uploaded-file" style={{
                                marginTop: '1rem',
                                padding: '0.75rem 1rem',
                                backgroundColor: '#f0f9ff',
                                border: '1px solid #bae6fd',
                                borderRadius: '0.375rem',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: '1rem'
                              }}>
                                <a
                                  href={`${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${item.orderPdfLink}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: '#0369a1',
                                    textDecoration: 'none',
                                    fontWeight: '500',
                                    fontSize: '0.875rem',
                                    flex: 1
                                  }}
                                >
                                  View Uploaded Order File
                                </a>
                                <button
                                  type="button"
                                  onClick={() => handleRemoveOrderFile(index)}
                                  style={{
                                    backgroundColor: '#ef4444',
                                    color: 'white',
                                    border: 'none',
                                    padding: '0.375rem 0.75rem',
                                    borderRadius: '0.25rem',
                                    fontSize: '0.75rem',
                                    fontWeight: '500',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="rem-div-btn">
                          <button
                            type="button"
                            className="court-remove-case"
                            onClick={() => removeOrder(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                );
              })
            )}
            <div className="add-div-btn">
              <button
                type="button"
                className="court-add-case"
                onClick={addOrder}
              >
                + Order
              </button>
            </div>
            <div className="dc-submit-section-form" ref={submitSectionRef}>
              <button className="submit-btn" type="submit" disabled={isLoading}>
                <span>{isLoading ? 'Processing...' : (isEdit ? 'Update District Court Case' : 'Submit District Court Case')}</span>
              </button>
            </div>
          </div>




        </form>
        <div className="dc-submit-section">
          <button
            className="dc-submit-btn"
            onClick={handleTopSubmit}
            type="button"
            disabled={isLoading}
          >
            <span>
              {isLoading
                ? "Processing..."
                : isEdit
                  ? "Update District Court Case"
                  : "Submit District Court Case"}
            </span>
          </button>
        </div>
      </div>
      <FetchingOverlay
        isVisible={isFetchingDetails}
        message="Fetching District Court Case Details"
      />
    </>
  );
};
